<div class="modal-header">
	<h5 class="modal-title">Nouvelle conversation</h5>
	<button
		type="button"
		class="btn-close"
		(click)="bsModalRef.hide()"
	></button>
</div>
<div class="modal-body" style="height: 75vh">
	<div class="container-fluid">
		<input
			type="text"
			class="form-control"
			placeholder="Recherche"
			[(ngModel)]="searchedName"
		/>

		<div
			*ngFor="
				let user of usersForNewConversation
					| filterUsersByEmployeeName: searchedName
			"
			role="button"
			(click)="selectUserForNewConversation(user)"
		>
			<div class="d-flex justify-content-center border-bottom ps-2 py-3">
				<div>
					<span class="me-2">{{ user.employee.firstName }}</span>
					<span class="me-2">{{ user.employee.lastName }}</span>
				</div>
			</div>
		</div>
	</div>
</div>
